import CamposCustomizados from '@/spa/campos-customizados/CamposCustomizados';

export default {
  path: 'campos-customizados',
  name: 'campos-customizados',
  component: CamposCustomizados,
};
